import {
    Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import colors from "../../../../colors";
import OTPInput from "otp-input-react";
import { texts } from "../../../../general/texts";

const DigitalbOTPCodeView = ({ isOpen, handleCloseModal, otp, setOtp, handleConfirmOtpCodeButtonClick, classes }) => {
  return (
    <Grid>
      <Dialog
        open={isOpen}
        onClose={handleCloseModal}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        PaperProps={{
          style: {
            borderRadius: "20px",
            width: "700px",
          },
        }}
      >
        <DialogTitle
          id="scroll-dialog-title"
          sx={{
            textAlign: "center",
            background: colors.gradientOrange,
            color: colors.white,
            fontSize: "1rem",
            fontFamily: "GerberaBold",
          }}
        >
          <span>OTP</span>
        </DialogTitle>
        <DialogContent
          sx={{
            fontSize: "1rem",
            color: colors.darkBlue,
            textAlign: "start",
            fontFamily: "GerberaLight",
            p: 5,
          }}
        >
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                color: colors.darkBlue,
                fontSize: "1rem",
                fontFamily: "GerberaBold",
              }}
            >
              {texts["message-subtitle-phone-verification-top-up"]}!
            </Typography>
          </Grid>
          <Grid sx={{ display: "flex", flexDirection: "column", rowGap: 2 }}>
            <Grid item container justifyContent={"center"} mt={5} mb={3}>
              <OTPInput
                inputStyles={{
                  borderTop: "none",
                  width: "60px",
                  borderLeft: "none",
                  outline: "none",
                  borderRight: "none",
                  borderBottomColor: colors.orange,
                  color: colors.darkBlue,
                  fontSize: "2rem",
                  paddingBottom: "3%",
                }}
                value={otp}
                onChange={setOtp}
                autoFocus
                OTPLength={6}
                otpType="number"
                disabled={false}
              />
            </Grid>
          </Grid>
          <Grid item md={12} xs={12} className={classes.buttonGrid}  >
            <Button disabled={otp.length !== 6} onClick={handleConfirmOtpCodeButtonClick} className={classes.button} >{texts["button-continue"]}</Button>
        </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default DigitalbOTPCodeView;
